import * as React from 'react';

interface IProps {
  className?: string;
}

export const PlayBtn: React.FC<IProps> = props => {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      fill="none"
      viewBox="0 0 48 48"
    >
      <path d="M24 0C10.745 0 0 10.745 0 24s10.745 24 24 24 24-10.745 24-24S37.255 0 24 0zm8.295 25.272l-12 7.5A1.5 1.5 0 0118 31.5v-15a1.5 1.5 0 012.295-1.272l12 7.5a1.502 1.502 0 010 2.544z" />
    </svg>
  );
};

PlayBtn.displayName = 'PlayBtn';
